import React, {useEffect, useState} from 'react';
import "./NewContentListItem.css";
import { formatDate } from '@/utils/globals/date-utils';
import { Image } from "primereact/image";
import { useCampaigns, useCreators } from "@/modules";

export default function(props) {
  const [campaignName, setCampaignName] = useState('Campaign Name');
  const [creator, setCreator] = useState('');
  const campaigns = useCampaigns();
  const creators = useCreators();

  useEffect(() => {
    campaigns.manager
      .loadSingle(props.item?.campaignId)
      .then((campaign) => {
        setCampaignName(campaign.name);
      });
      
    const ownerId = props.item?.owner?.id ?? props.item?.owner?._id;

    if(!props.item?.owner.profile && ownerId) {
      creators.manager
        .load(ownerId)
        .then((result) => {
          setCreator(result);
      });
    }
  }, []);

  return (
    <div className={'content-list-item'} onClick={props.handleRouting}>
      <Image src={props.item?.thumbnails?.medium?.url} alt={'content thumbnail'} className={'contentThumbnail'}/>
      <p className={'contentTitle'}>{props.item?.title}</p>
      <div className={'creator'}>
        <Image src={props.item?.owner.profile?.photo ? props.item?.owner.profile?.photo : creator.profile?.photo} alt={'creator photo'} className={'creatorPhoto'}/>
        <div className={'creatorAndCampaignInfo'}>
          <p className={'creatorName'}>{props.item?.owner.name ? props.item?.owner.name : creator.name}</p>
          <p className={'campaign'}>{campaignName}</p>
        </div>
      </div>
      <div className={'date'}>
        { formatDate(props.item?.publishedAt) }
      </div>
    </div>
  )
}
